import React from 'react';

import './spinner.css';

const Spinner = (): JSX.Element => {
  return (
    <img src="./assets/spinner.png" className="rotating-image" alt="Spinner" />
  );
};

export default Spinner;
